$shm_showcase $mol_book2_catalog
	menu_title \Каталог компонентов
	title \Каталог компонентов
	param \component
	plugins /
		<= Theme $mol_theme_auto
	Menu $shm_list_page
		title <= menu_title
		head_content /
			<= Home $mol_link
				title <= menu_title
				arg * component null
		body <= menu_body
		foot <= menu_foot
		filter? <=> query? \
		filter_hint \Название или FQN
		sort_by? => sort_by?
		sort_order? => sort_order?
		sort_options *
			title \Наименование
			id \FQN
	menu_body /
		<= Results $mol_list
			rows <= groups_visible /$mol_view
			Empty <= Empty $mol_paragraph
				title \Ничего не найдено. Измените запрос.
	Group* $shm_showcase_group
		title <= group_title* \
		content <= group_links* /$mol_view
	Spread* $shm_showcase_component
		entry_id <= component_id* \
	Info* $shm_showcase_info
		entry_id <= component_id* \
	Spread_default <= Welcome $mol_page
		title \Компоненты
		body /
			<= Overview $shm_showcase_table
				entries <= entries_ordered /
